import Login from '../pages/auth/Login';
import PasswordRecovery from '../pages/auth/PasswordRecovery';
import ProtectedRoute from './ProtectedRoute';
import { Navigate, Routes, Route } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import UserList from '../pages/users/UserList';
import UserDetails from '../pages/users/UserDetails';
import Dashboard from '../pages/dashboard/Dashboard';
import DiscountList from '../pages/discounts/DiscountList';
import MigrationDashboard from '../pages/MigrationDashboard';

export default function AdminRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<PasswordRecovery />} />
      <Route path="/reset-password" element={<PasswordRecovery reset />} />
      <Route element={<ProtectedRoute />}>

      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/users" element={<UserList />} />
        <Route path="/users/:userId" element={<UserDetails />} />
        <Route path="/discounts" element={<DiscountList />} />
        <Route path="/migrationdashboard" element={<MigrationDashboard />} />
      </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
